import { ChapterPage } from './ChapterPage';
export default ChapterPage;
